import LocationState from '@/store/modules/locations/LocationState';

const state: LocationState = {
    activeLocationPanelItem: null,
    mobileMenuOpened: false,
};

export default state;
